<template>
  <v-dialog v-model="visibility" persistent max-width="480px">
    <v-card v-if="visibility">
      <v-form v-model="valid" ref="form">
        <div style="width: 100%; max-height: 90vh; overflow: auto">
          <!-- Reset password mode -->
          <v-card-text class="px-6 py-0">
            <v-row no-gutters class="dialog-title py-6">Reset Password</v-row>

            <!-- Password -->
            <v-row no-gutters>
              <v-col cols="12" class="input-title mb-1">New Password</v-col>
              <v-col cols="auto" style="width: 272px">
                <v-text-field
                  v-model="password"
                  dense
                  outlined
                  :rules="password_rules"
                  :type="password_visibility ? 'text' : 'password'"
                  :append-icon="password_visibility ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="password_visibility = !password_visibility"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Confirm Password -->
            <v-row no-gutters>
              <v-col cols="12" class="input-title mb-1">Confirm New Password</v-col>
              <v-col cols="auto" style="width: 272px">
                <v-text-field
                  v-model="confirm_password"
                  dense
                  outlined
                  :rules="confirm_password_rules"
                  :type="confirm_password_visibility ? 'text' : 'password'"
                  :append-icon="confirm_password_visibility ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="confirm_password_visibility = !confirm_password_visibility"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn @click="$store.commit('RESET_RESET_PASSWORD_DIALOG')" outlined rounded class="text-capitalize px-3">Cancel</v-btn>
            <v-btn @click="submit" :disabled="is_submit_btn_disable" color="#1B65F2" :dark="!is_submit_btn_disable" rounded class="text-capitalize px-3"> Confirm </v-btn>
          </v-card-actions>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ResetPasswordDialog',
  data() {
    return {
      valid: false,
      password: null,
      confirm_password: null,
      password_rules: [(v) => !!v || 'Password is required'],
      confirm_password_rules: [(v) => (!!v && v === this.password) || 'Confirm password is not same as password'],

      password_visibility: false,
      confirm_password_visibility: false
    }
  },
  computed: {
    ...mapState(['resetPasswordDialog', 'auth']),
    visibility: {
      get() {
        return this.resetPasswordDialog.visibility
      },
      set(value) {
        this.$store.commit('SET_RESET_PASSWORD_DIALOG_VISIBILITY', value)
      }
    },
    is_submit_btn_disable() {
      return this.resetPasswordDialog.is_submit_btn_disable
    }
  },
  watch: {
    visibility() {
      if (this.$refs.form) this.$refs.form.reset()
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate()
      if (this.valid) {
        this.$store.dispatch('resetPassword', { password: this.password, type: 'dialog' })
      }
    }
  }
}
</script>
<style scoped>
.v-input--selection-controls.v-input {
  margin-top: 0;
  padding-top: 0;
}

:deep(.v-input--selection-controls .v-input__slot > .v-label) {
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}
</style>
